import React from 'react';
import { Text, StyleSheet } from 'react-native';
import Theme from '../../theme';
import { verticalScale } from 'react-native-size-matters';

const FormLabel = ({ title }) => (
  <Text style={styles.formLabelStyle}>
    {title}
  </Text>
);

const styles = StyleSheet.create({
  formLabelStyle: {
    fontSize: 14,
    fontFamily:Theme.Custom400,
    paddingVertical: 5,
    color: Theme.GREY_MEDIUM,
  },
});

export default FormLabel;
